import { z } from "zod";

export const createStoryCommentSchema = z.object({
	content: z.string().min(1).max(1000),
	parent_id: z.string().optional(),
});

export type CreateStoryCommentPayload = z.infer<typeof createStoryCommentSchema>;
